var map = {
	"./_ic_arrow.svg": "s3DU",
	"./background-wordfinder-menu.svg": "rGKb",
	"./bd_ydr.svg": "Vgd/",
	"./ccpa_nav_icon.svg": "ebgY",
	"./google-logo.svg": "eizi",
	"./homepage-bg-md.svg": "K/Wd",
	"./homepage-bg-xl.svg": "B+2D",
	"./homepage-bg-xs.svg": "BNV3",
	"./ic_arrow.svg": "sgv1",
	"./ic_def_normal.svg": "VfUZ",
	"./ic_def_selected.svg": "JrrF",
	"./ic_speaker.svg": "zOBf",
	"./ic_speaker_orange.svg": "6HbQ",
	"./icon-az-sorting.svg": "LjFX",
	"./icon-back-arrow.svg": "7tP5",
	"./icon-check-mark-green.svg": "XkoA",
	"./icon-check-mark.svg": "2iMz",
	"./icon-clear.svg": "iJr0",
	"./icon-copy-green.svg": "N9Bk",
	"./icon-copy-grey.svg": "fSUn",
	"./icon-cross-dark.svg": "v7eT",
	"./icon-cross-grey.svg": "c/hI",
	"./icon-erase.svg": "8LKf",
	"./icon-expandable.svg": "YH6I",
	"./icon-filter-blue.svg": "mP4G",
	"./icon-filter-focused.svg": "nRKS",
	"./icon-filter.svg": "Ot6c",
	"./icon-history.svg": "qvqb",
	"./icon-list.svg": "gHG8",
	"./icon-location.svg": "9VHB",
	"./icon-magnify-glass.svg": "IP0E",
	"./icon-notification.svg": "EdOx",
	"./icon-orange-magnify-glass.svg": "uy8f",
	"./icon-pressed-magnify-glass.svg": "D/QN",
	"./icon-proceed.svg": "mkWV",
	"./icon-quote-close.svg": "b2w+",
	"./icon-report-flag-orange.svg": "gK5y",
	"./icon-report-flag.svg": "8Tmc",
	"./icon-sentences.svg": "l3c3",
	"./icon-sign-out.svg": "3hva",
	"./icon-social-email.svg": "GSGb",
	"./icon-social-fb.svg": "rQoJ",
	"./icon-social-tw.svg": "Wf5k",
	"./icon-star-grey.svg": "RuMV",
	"./icon-star-orange.svg": "fDJs",
	"./icon-star-white.svg": "tmPV",
	"./icon-thumb-down-red.svg": "f9m8",
	"./icon-thumb-down.svg": "VgXW",
	"./icon-thumb-up-green.svg": "uSiw",
	"./icon-thumb-up.svg": "K08K",
	"./icon-user-hover.svg": "TeEo",
	"./icon-user-normal.svg": "6w2N",
	"./icon-wf-spot.svg": "KJnK",
	"./icon-word-audio.svg": "HkAA",
	"./icon-world-blue.svg": "0f7c",
	"./icon-world-dark-blue.svg": "pVq8",
	"./icon-world.svg": "452d",
	"./icon_dictionary_normal.svg": "OUa/",
	"./info-icon.svg": "9oph",
	"./logo-xl.svg": "9kyD",
	"./logo-xs.svg": "ampe",
	"./mobile-nav-tiles.svg": "fibm",
	"./nav-caret-blue.svg": "PTUW",
	"./nav-caret.svg": "RRMq",
	"./new-logo-xs.svg": "alOK",
	"./save-word-img.svg": "hHm8",
	"./thesaurus-no-results.svg": "dxHA",
	"./wf-logo-dark-xs.svg": "RxTI",
	"./wf-logo-xl.svg": "x/qw",
	"./wf-logo-xs.svg": "NEX8",
	"./yd-badge.svg": "3sf9",
	"./yd-logo-spanish.svg": "5Ou3",
	"./yd-logo.svg": "8Vp3",
	"./yd-magnifier.svg": "B7KJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 2